import React from 'react';
import Nav from './nav.js';
import { BrowserRouter as Router, Route, NavLink, Switch } from 'react-router-dom'; // bring in a hook, and use a shorter alias, bring in another hook called switch
import Articles from './mainPageComponents/articles';
import ArticlesTagStory from './mainPageComponents/articles-tag-story';
import ArticlesTagDevelopment from './mainPageComponents/articles-tag-development';
import ArticlesTagPublished from './mainPageComponents/articles-tag-published';
import ArticlesTagLifeCharge from './mainPageComponents/articles-tag-life-charge';
import About from './mainPageComponents/aboutDBH';
import HelloWorld from './articles/hello-world';
import Home from './mainPageComponents/home';
import Error from './mainPageComponents/Error';
import { AnimatePresence, motion } from 'framer-motion';
import aBigDecision from './articles/a-big-decision.js';
import PutOnYourHelmet from './articles/put-on-your-helmet.js';
import noFearOfDating from './articles/the-dating-game.js';
import ScrollToTop from './mainPageComponents/scrollToTop.js';
import theRightSide from './articles/go-with-God.js';
import AStateIsBorn from './articles/a-state-is-born.js';
import ByAnyOtherName from './articles/by-any-other-name.js';
import AmazonAndAlCapone from './articles/amazon-and-al-capone.js';

export class Routes extends React.Component {
    render() {
        return(
<div>
  {/* all the routing you want done needs to be insie the <Router> tags - that you called as BrowserRouter from the react-router-dom library everything inside these tags will have the ability to use routing
  the <Route> is what takes you there. It takes two attributes, 1 - path="" which specifies the path you are creating, 2- component - the component that renders on this path */}
        <Router>  
        <ScrollToTop />
      <Nav /> 
      <AnimatePresence>
          <Switch>
          {/* Switch will make sure you don't render multiple pages on the same path. It goes inside the <Router> tags. */}
  <div className="App">
      <Route path="/" exact component={Home} /> 
      {/* the "/" means homepage. But since every page starts with a /, it can mean all pages - we need a solution.
      Simply add the attribue "exact" and only the exact match, the homepage with just the '/' will be selected */}
      <Route path="/articles" exact component={Articles} />
      <Route path="/articles-tag-story" exact component={ArticlesTagStory} />
      <Route path="/articles-tag-development" exact component={ArticlesTagDevelopment} />
      <Route path="/articles-tag-published" exact component={ArticlesTagPublished} />
      <Route path="/articles-tag-life-charge" exact component={ArticlesTagLifeCharge} />
      <Route path="/about" exact component={About} />
      <Route path="/articles/hello-world" exact component={HelloWorld} />
      <Route path="/articles/a-big-decision" exact component={aBigDecision} />
      <Route path="/articles/put-on-your-helmet" exact component={PutOnYourHelmet} />
      <Route path="/articles/the-dating-game" exact component={noFearOfDating} />
      <Route path="/articles/go-with-God" exact component={theRightSide} />
      <Route path="/articles/a-state-is-born" exact component={AStateIsBorn} />
      <Route path="/articles/by-any-other-name" exact component={ByAnyOtherName} />
      <Route path="/articles/amazon-and-al-capone" exact component={AmazonAndAlCapone} />
            
      </div>
      
      </Switch>        
      </AnimatePresence>  
      </Router>
      </div>

        )
     }
}

export default Routes;